import React from 'react';
import styled from 'styled-components';
import { breakpoint, theme } from '../../theme';
import { UIText } from '../typography';

export type LotBadgeProps = {
  label?: string;
  href?: string;
  altText?: string;
  iconOnClick?: () => void;
};

const Wrapper = styled.div`
  cursor: auto;
  width: 44px;
  height: 44px;
  display: flex;
  justify-content: center;
`;

const LabelWrapper = styled(UIText).attrs({ size: 'md' })`
  position: absolute;
  font-weight: bold;
  color: ${theme.colors.primary.white};
  z-index: 1;
  cursor: auto;
  -webkit-text-stroke-width: 0.5px;
  -webkit-text-stroke-color: ${theme.colors.neutrals.border.dark};
  top: 8px;
  ${breakpoint('sm')`
        left: 13px;
      `};
`;

const SvgWrapper = styled.div`
  position: absolute;
  width: 100%;
  max-height: 100%;
  cursor: auto;
`;

export const LotBadge: React.FC<LotBadgeProps> = ({
  label,
  href,
  altText,
  ...props
}) => {
  return (
    <Wrapper {...props}>
      {label && <LabelWrapper>{label}</LabelWrapper>}
      <SvgWrapper>
        <img width={44} height={44} src={href} alt={altText}></img>
      </SvgWrapper>
    </Wrapper>
  );
};
